import { createBrowserClient } from '@supabase/ssr'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ 請設定 Supabase 環境變數！請參考 .env.example')
}

// Realtime 連線保活（Supabase 官方針對背景分頁斷線的建議設定）
// - worker：heartbeat 改在 Web Worker 跑。背景分頁的主執行緒 timer 會被瀏覽器節流，
//   heartbeat 送不出去，server 就會把連線斷掉
// - heartbeatCallback：發現已斷線就主動重連，不等 library 的 backoff。
//   沒有任何 channel 時不重連，避免把刻意關掉的連線又打開
// 測試環境（jsdom）沒有 Worker，開了會直接 throw，所以要先判斷
const canUseWorker = typeof window !== 'undefined' && typeof window.Worker !== 'undefined'
let client = null
const handleHeartbeat = (status) => {
  if (status === 'disconnected' && client && client.realtime.getChannels().length > 0) {
    client.realtime.connect()
  }
}

// 使用 @supabase/ssr 的 createBrowserClient
// 同 origin 下自動讀取主系統設定的 Supabase auth cookie，共用 session
// token refresh 由主系統的 Supabase session 自動處理
client = createBrowserClient(supabaseUrl, supabaseAnonKey, {
  realtime: { worker: canUseWorker, heartbeatCallback: handleHeartbeat },
})

export const supabase = client
